export default "__VITE_ASSET__ByIeC1Kx__"